module.exports = "/images/circle-marker-car-45.png?6c2e9ab3b4768f6998993583f07f05ff";